import { Flex, Page, usePaypingContext } from "@payping/web-components";
import React from "react";
import classnames from "classnames";

type Props = {
  children: React.ReactNode;
  classNames?: string;
};

const PageComponentForHandlingCrispInMobile: React.FC<Props> = ({ children, classNames }) => {
  const { breakpoints } = usePaypingContext();
  const { lg } = breakpoints;

  const Styles = {
    PagePadding: lg ? "tw:pl-4! tw:pr-8!" : "tw:p-4!",
    FlexContentWrapper: "tw:w-full tw:gap-4 tw:xl:gap-12",
  };

  return (
    <Page className={classnames(["tw:mb-52!", Styles.PagePadding, classNames])}>
      <Flex vertical className={Styles.FlexContentWrapper}>
        {children}
      </Flex>
    </Page>
  );
};

export default PageComponentForHandlingCrispInMobile;
